import React from "react";
import {Trans} from "react-i18next";
import appname from "../appname";
import {routes} from "../routes";
import {I18nService} from "../service/i18nService";

export const TermsAndConditions = ({checked, onChange}) => {
    const i18nService = new I18nService();
    const lang = i18nService.getLanguage();

    const href = `${appname}/${lang}/${routes["privacyPolicy"][lang]}`;

    return (
        <div className="form-check">
            <input
                className="form-check-input"
                type="checkbox"
                id="termsCheck"
                checked={checked}
                onChange={onChange}
                required
            />
            <label className="form-check-label" htmlFor="termsCheck">
                <Trans
                    i18nKey="pages.common.termsAndConditions.agree"
                    components={{
                        a: (
                            <a
                                href={href}
                                target="_blank"
                                rel="noopener noreferrer"
                            />
                        ),
                    }}
                />
            </label>
        </div>
    );
};

